<button [id]="idVal" type="button" (click)="onClick.emit($event)" class="btn st-button-cancel rounded-pill">
  <i class="bi bi-x-lg"></i>
    {{label}}
</button>
